import { Component } from 'react';
import PropTypes from 'prop-types';
import ErrorComponent from './ErrorComponent';
import hasErrors from '../../../helper/form/hasErrors';
import replaceValueInEvent from '../../../helper/replaceValueInEvent';

class CheckboxComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value,
    };

    this.onChangeHandler = this.onChangeHandler.bind(this);
    this.onBlurHandler = this.onBlurHandler.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.setState({ value: this.props.value });
    }
  }
  onChangeHandler(e) {
    if (this.props.readOnly) {
      return;
    }

    this.setState({ value: e.target.checked });
    this.props.onChangeHandler(replaceValueInEvent(e, e.target.checked));
  }

  onBlurHandler(e) {
    this.props.onBlurHandler(e);
  }

  render() {
    const {
      id,
      name,
      label,
      className,
      errors,
      readOnly,
      onFocusHandler,
      children,
    } = this.props;

    const inputClassNames = 'form-control';
    let classNames = 'checkbox';
    if (className) {
      classNames += ` ${className}`;
    }

    if (hasErrors(errors)) {
      classNames += ' has-errors';
    }

    return (
      <div>
        <div className={classNames}>
          <input
            checked={this.state.value}
            type="checkbox"
            name={name}
            id={id}
            readOnly={readOnly}
            onChange={this.onChangeHandler}
            onBlur={this.onBlurHandler}
            onFocus={onFocusHandler}
            className={inputClassNames}
          />
          <label htmlFor={id} className="checkbox_box" />
          {children || <label htmlFor={id}>{label}</label>}
        </div>
        <ErrorComponent errors={errors} />
      </div>
    );
  }
}

CheckboxComponent.propTypes = {
  id: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  className: PropTypes.string,
  onChangeHandler: PropTypes.func,
  onBlurHandler: PropTypes.func,
  onFocusHandler: PropTypes.func,
  value: PropTypes.bool,
  errors: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

CheckboxComponent.defaultProps = {
  className: null,
  readOnly: false,
  value: false,
  name: '',
  onChangeHandler: () => {},
  onBlurHandler: () => {},
  onFocusHandler: () => {},
  errors: null,
  children: null,
};

export default CheckboxComponent;
